<template>
  <div class="line">
    <div class="mesLine" ref="mes_statistics"></div>
  </div>
</template>

<script>
  import EChart from 'echarts'

  export default {
    props:{
        mesData:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    data() {
      return {
        mes_statistics: {
          option: {},
          chart: null,
          element: {},
        },
        mes_data:{},
        x_data:[],
        y_data:[],
         chartArray:['mes_statistics'],
        interval:null,
        x_dataLen:0,
      }
    },

    mounted() {
    

    },
    watch:{
        mesData:{
            handler:function(newVal,oldVal){
              setTimeout(()=>{
                this.pageInit();
              },500)
            },
            deep:true
        },
 
    },
    destory() {

    },
    beforeDestroy(){
      if(this.interval){
        clearInterval(this.interval);
      }
    },
    methods: {
        
        
        pageInit(){
            if(JSON.stringify(this.mesData) !== "{}"){
              console.log('meslien浓度数据-=-=-=-='+JSON.stringify(this.mesData))

              this.mes_data = this.$deepClone(this.mesData);
                for(var i in this.mes_data.time){
                    let time = this.mes_data.time[i];
                    this.x_data.push(time.split(" ")[1].substring(0,5));
                }
 
  
                this.initData();
            }
        },
        initData() {
            var unit = ('('+this.mesData.unit+')')
            var serieData = [];
             var colors = ["#00eaf0","red","blue","#2EF7F3","#FFFFFF"];
            this.mes_data.data.filter((item, i) => {
                    console.log('循环==i==', JSON.stringify(item))
                    var serie = {
                        name:this.mes_data.name[i],
                        type: 'line',
                        symbol:"circle",
                        symbolSize:8,
                        itemStyle: {
                            normal: {
                                color: colors[i],  // 会设置点和线的颜色，所以需要下面定制 line
                                shadowColor: colors[i],  // 点边线的颜色
                                shadowBlur: 10 ,    // 点边线的阴影
                            }
                        },
                        lineStyle: {
                            normal: {
                                color: colors[i]   // 线条颜色
                            }
                        },
                        data: this.mes_data.data[i]
                    };
                    serieData.push(serie)
                })
            this.mes_statistics.option = {
                title:{
                    text:'浓度曲线',
                    left:0,
                    textStyle:{
                        color:'#ffffff',
                        fontSize:18,
                        fontWeight:'normal'
                    }
                },
                legend: {
                    show:true,left:"right",data:this.mes_data.name,y:"5%",
                    itemWidth:18,itemHeight:12,textStyle:{color:"#fff",fontSize:14},
                },
                color:colors,
                grid: {
                    left: '1%',
                    top:"30%",
                    bottom: "5%",
                    right:"1%",
                    containLabel: true
                },
                tooltip : {
                    trigger: 'axis',
                    backgroundColor:'#123e8e',
                    axisPointer : {
                        // type : 'shadow'
                    },
                },
                xAxis: [
                    {
                        type: 'category',
                        axisLine: {
                            show: true,
                            lineStyle:{
                                color:'#004d9f'
                            }
                        },
                        axisLabel:{

                            interval:'auto',
                            rotate:40,
                            textStyle:{
                                color:'#9ea7c4',
                                fontSize:10
                            },
                            inside:false,  //x轴的刻度朝内

                        },
                        axisTick : {
                            show: true,
                            inside:true,  //x轴的刻度朝内
                        },
                        data:this.x_data,
                    },
                ],
                yAxis: [
                    {
                        name: unit,
                        nameTextStyle: {
                            color: "#91a8b6",
                            fontSize: 10,
                            padding: [0, 0, 0, 0]
                        },
                        type: 'value',
                        axisTick : {
                            show: false
                        },
                        splitLine: {
                            show:true,
                             lineStyle: {
                                color: '#003b8b',
                            },
                        },
                        axisLabel:{
                            textStyle:{
                                color:'#91a9c0',
                                fontSize:10
                            }
                        },
                        axisLine: {
                            show: false,
                            lineStyle:{
                                color:'#6173A3'
                            }
                        },
                    },
                ],
                series:serieData
            };
            if(this.mes_statistics.chart!=null&&this.mes_statistics.chart!=''&&this.mes_statistics.chart!=undefined){
                this.mes_statistics.chart.dispose();
            }
            this.mes_statistics.chart = EChart.init(this.$refs.mes_statistics);
            this.mes_statistics.chart.setOption(this.mes_statistics.option,true);


        },

        //释放图表，销毁对象
        disposeAllChart(){
            let i = 0 , len = this.chartArray.length
            for (;i < len; i++){
                let a = this.chartArray[i]
                if(this[a].chart){
                    this[a].chart.dispose()
                }
            }
            this.initData()
        }
    }
  }
</script>
<style lang="less" scoped>
.line{
    width: 100%;
    height: 100%;
    // background: chocolate;
    .mesLine{
        width: 100%;
        height: 100%;
    }
}
  .mesLine {
    border-right: 0;
    border-left: 0;
    /* width: 350px;
    height: 220px; */
    /* background-color: red; */
    // width: 100%;
    // height: 220px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/mes_line.vue